import React from "react";
import styles from "./style.module.scss";
import { useTranslation } from "react-i18next";

type TextExample = {
	title: string;
	text: string;
};

type TextExampleData = {
	title: string;
	aiVersion: TextExample;
	humanizedVersion: TextExample;
};

export const TextExampleSection: React.FC = () => {
	const { t } = useTranslation();
	const data = t("textExampleSection", { returnObjects: true }) as TextExampleData;

	if (typeof data !== "object" || !data) {
		return null;
	}

	return (
		<div className={styles.ShadowsReference}>
			<div className={`${styles.ShadowsReference__content} app-container`}>
				<div className={styles.ShadowsReference__leftPart}>
					<h1 className={styles.ShadowsReference__subTitle}>{data.title}</h1>
					<div className={styles.ShadowsReference__comparison}>
						<div className={styles.ShadowsReference__card}>
							<h3 className={styles.ShadowsReference__subsubTitle}>
								{data.aiVersion.title}
							</h3>
							<p className={styles.ShadowsReference__paragraph}>{data.aiVersion.text}</p>
						</div>
						<div
							className={`${styles.ShadowsReference__card} ${styles.ShadowsReference__card_humanized}`}
						>
							<h3 className={styles.ShadowsReference__subsubTitle}>
								{data.humanizedVersion.title}
							</h3>
							<p className={styles.ShadowsReference__paragraph}>
								{data.humanizedVersion.text}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
